import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethodType } from '@galaxy/billing';
import { TranslateService } from '@ngx-translate/core';

/**
 * Transforms a `PaymentMethodType` enum value from to its corresponding title string.
 * It is useful for displaying user-friendly names of payment methods in UI components.
 *
 * @example
 * ```html
 * <!-- Assume 'paymentMethod' is a property in the component with a value of PaymentMethodType.CARD -->
 * <div>{{ paymentMethod | paymentTypeToTitle }}</div>
 * <!-- Output will be "Debit or credit card" -->
 * ```
 */
@Pipe({
  standalone: true,
  name: 'paymentTypeToTitle',
})
export class PaymentTypeToTitlePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  typeToTranslationKey = {
    [PaymentMethodType.CARD]: 'PAYMENT_METHOD_SELECTOR.CARD_TITLE',
    [PaymentMethodType.ACH_DEBIT]: 'PAYMENT_METHOD_SELECTOR.ACH_TITLE',
    [PaymentMethodType.ACSS_DEBIT]: 'PAYMENT_METHOD_SELECTOR.ACSS_TITLE',
  };

  transform(value: PaymentMethodType): string {
    return this.translateService.instant(this.typeToTranslationKey[value]) || value;
  }
}
